import { useCallback, useState } from 'react';

// Field-role session for contractors (پیمانکار), mirroring useInstallerSession
// with a distinct localStorage key so a contractor and an installer can be logged
// in on the same device without clobbering each other.
const KEY = 'contractor_session_token';

export function useContractorSession() {
  const [token, setTokenState] = useState(() => localStorage.getItem(KEY));
  const setToken = useCallback((t) => {
    if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY);
    setTokenState(t || null);
  }, []);
  const logout = useCallback(() => setToken(null), [setToken]);
  return { token, setToken, logout };
}
